import moment from "moment";
import { Box,  TableCell, TableRow } from "@mui/material"
import { formatDate, dateMonthYearFormatTime } from "../../../constants";

const ActivitiesListing = ({ item,type='' }) => {
    return (
        <TableRow>
            <TableCell>{item?.short_description ? item?.short_description : "--"}</TableCell>
            {type === 'fleet' ? <TableCell >{item?.hierarchy?.data?.asset?.name ? item?.hierarchy?.data?.asset?.name : "--"}</TableCell> : null}
            {type === 'fleet' ? <TableCell >{item?.hierarchy?.data?.lease?.reference_code ? item?.hierarchy?.data?.lease?.reference_code : "--"}</TableCell> : null}
            <TableCell>{item?.module_display_name ? item?.module_display_name : "--"}</TableCell>
            <TableCell>{item?.activity_type_display ? item?.activity_type_display : "--"}</TableCell>
            <TableCell>
                <Box>
                    <Box> {item?.performed_by_user?.name ? item?.performed_by_user?.name : "--"} </Box>
                    <Box style={{ fontSize: "11px", background: "#d6daf9", padding: "1px", border: "1px solid #d6daf9", borderRadius: "4px" }}> {item?.performed_by_user?.email ? item?.performed_by_user?.email : "--"} </Box>
                </Box>
            </TableCell>
            <TableCell> {item?.performed_at ? moment(formatDate(item?.performed_at)).format(dateMonthYearFormatTime) : "--"}</TableCell>
            <TableCell>{item?.ip_address ? item?.ip_address : "--"}</TableCell>
            <TableCell >{item?.user_agent_details?.device?.type ?item?.user_agent_details?.device?.type :"--" }</TableCell>
            <TableCell >{item?.user_agent_details?.browser?.name ?item?.user_agent_details?.browser?.name  :"--" }</TableCell>
            <TableCell >{item?.user_agent_details?.os?.name ?item?.user_agent_details?.os?.name  :"--" }</TableCell>
        </TableRow>
    )
}
export default ActivitiesListing;